import { motion } from "framer-motion";

const VIEWPORT = { once: true, margin: "-60px" };
const VISIBLE = { opacity: 1, y: 0 };
const MASK_FROM = { y: "115%" };
const MASK_TO = { y: 0 };
const MASK_EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={VISIBLE}
        viewport={VIEWPORT}
        transition={{ duration: 0.8, delay, ease: "easeInOut" }}
    >
        {children}
    </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={MASK_FROM}
            animate={MASK_TO}
            transition={{ duration: 1.1, delay, ease: MASK_EASE }}
        >
            {children}
        </motion.span>
    </span>
);
